/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */
import { uiPushClient } from './clientInstance';

export const configure = options => uiPushClient.configure(options);
export const subscribe = (service, eventType, handler, callbacks) =>
  uiPushClient.subscribe(service, eventType, handler, callbacks);
export const unsubscribe = componentSubscriptionKey => uiPushClient.unsubscribe(componentSubscriptionKey);

export { useUiPushSubscription } from './hooks/useUiPushSubscription';
